module.exports = __webpack_public_path__ + "90b6ab0cb5357e958efd34a5483e5b15.pdf";